import React from 'react'
import { Box, Container, Grid, Typography } from '@material-ui/core'
import {
  ContactChannels,
  HeroSection,
  LinkWithIcon,
  LocationCard,
  PageForm,
  RichText,
  XRayText,
} from '../../components'
import { useStyles } from './contactUs.style'
import { contentfulArrayToObject } from '../../utils/cms'

const ContactPage = ({ data = {}, location, t }) => {
  const featureEntries = contentfulArrayToObject(data.feature || [])

  const {
    ContentfulSectionText,
    ContentfulContactChannels: contactChannels,
    ContentfulPageSection: pageSection,
  } = featureEntries || {}

  const styles = useStyles()

  const sections = Array.isArray(ContentfulSectionText)
    ? ContentfulSectionText
    : [ContentfulSectionText]

  return (
    <main>
      <HeroSection {...data.hero} t={t} />

      <Container maxWidth="lg">
        <Grid container className={styles.mainFormContainer}>
          {/* left section */}

          <Grid item lg={4} md={5} xs={12} className={styles.contactSidebar}>
            {contactChannels && <ContactChannels data={contactChannels} />}
          </Grid>
          <Grid item md={1} />
          {/* right section: includes form */}
          <Grid
            item
            lg={7}
            md={6}
            xs={12}
            className={styles.contactFormSection}
          >
            {sections.map((section) => {
              return (
                <Box
                  className={styles.section}
                  key={`page-section-${section.title}`}
                >
                  <XRayText
                    variant="h3"
                    wrapperClass={styles.sectionHeading}
                    content={section.title}
                  />
                  {section.sectionText && (
                    <RichText
                      variant="body1"
                      document={JSON.parse(section.sectionText.raw)}
                    />
                  )}
                  {section.form &&
                    section.form.map((formData) => (
                      <PageForm
                        key={formData.title}
                        data={formData}
                        source={location.pathname}
                        t={t}
                      />
                    ))}
                  {section.link && <LinkWithIcon {...section.link} />}
                </Box>
              )
            })}
          </Grid>
          {pageSection && (
            <Grid xs={12} item className={styles.branchesSectionHeadingSection}>
              <XRayText
                variant="h3"
                wrapperClass={styles.branchesSectionHeading}
                content={pageSection.heading}
              />
              {pageSection.locationCards && (
                <Box className={styles.branchWrapper}>
                  {pageSection.locationCards?.map((branch) => (
                    <LocationCard
                      {...branch}
                      t={t}
                      key={`key-${branch.name}`}
                    />
                  ))}
                </Box>
              )}

              {pageSection.description && (
                <div className={styles.branchDescription}>
                  <Typography variant="body2">
                    {pageSection.description.description}
                  </Typography>
                </div>
              )}
            </Grid>
          )}
        </Grid>
      </Container>
    </main>
  )
}

export default ContactPage
